import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Box, Button, Pill } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import RouteKey from '../../../routes/key';

const { announcement } = RouteKey.child;
const { allNotices } = RouteKey.announcement.child;

const useStyles = makeStyles()((theme) =>
({
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1.5),
  },
  noticeBoardIcon: {
    color: theme.color.text.textHeader,
  },
  viewAllButton: {
    padding: 0,
    minWidth: 0,
  },
}));

interface NoticeBoardHeaderProps {
  totalAnnouncements: number;
}

const NoticeBoardHeader = ({ totalAnnouncements }: NoticeBoardHeaderProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const history = useHistory();

  const handleViewAllButton = () => history.push(`/${announcement}/${allNotices.route}`);

  return (
    <Box className={classes.header}>
      <Box className={classes.titleContainer}>
        <IconWithLabel
          iconName={IconName.notice}
          className={classes.noticeBoardIcon}
          gap={12}
          iconSize="L"
          typographyProps={{
            variant: 'h3',
          }}
          label={t('admin->>AnnouncementNoticeBoard.NoticeBoard')}
        />
        <Box marginTop={2}>
          <Pill label={`${totalAnnouncements}`} variant="info" />
        </Box>
      </Box>
      <Button
        variant="text"
        color="primary"
        className={classes.viewAllButton}
        disabled={!totalAnnouncements}
        onClick={handleViewAllButton}
      >
        {t('admin->>AnnouncementNoticeBoard.ViewAll')}
      </Button>
    </Box>
  );
};

export default NoticeBoardHeader;
